module.exports = _.merge;


//////////////////
// WEBPACK FOOTER
// external "_.merge"
// module id = 618
// module chunks = 0